import api from "./api";

const isSupported = () =>
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

export const registerWebPushSubscription = async ({ askPermission = false } = {}) => {
  if (!isSupported()) {
    return { ok: false, reason: "unsupported" };
  }

  if (askPermission && Notification.permission === "default") {
    await Notification.requestPermission();
  }

  if (Notification.permission !== "granted") {
    return { ok: false, reason: Notification.permission };
  }

  const registration = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.publicKey);

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey
    });
  }

  await api.post("/push/subscriptions", {
    subscription: subscription.toJSON()
  });

  return { ok: true };
};

export const refreshWebPushSubscription = async () => {
  try {
    return await registerWebPushSubscription({ askPermission: false });
  } catch (error) {
    console.warn("No se pudo sincronizar la suscripción Web Push:", error);
    return { ok: false, reason: "sync-error" };
  }
};

export const requestWebPushPermission = async () => {
  try {
    return await registerWebPushSubscription({ askPermission: true });
  } catch (error) {
    console.warn("No se pudo activar Web Push:", error);
    return { ok: false, reason: "request-error" };
  }
};
